
import ProductService from './ProductService';

export { default } from './ProductService';
export const productService = new ProductService();
